import { Checkbox, IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../../../../Instances/ModalMenu/ModalMenu'
import useStyle from './useStyle'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getApplicationInstanceEAuthz } from '../../../../../redux/actions/eAuthz'

import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import { getSuborganizations } from '../../../../../redux/actions/Suborganizations'

function TableItem ({ item }) {
  const classes = useStyle()
  const dispatch = useDispatch()
  const [details, setdetails] = useState(null)
  const [loading, setloading] = useState(false)
  const [suborg, setsuborg] = useState(null)

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    }
    return formattedDate
  }
  const getSubOrg = async () => {
    const response = await dispatch(
      getSuborganizations(item.baseSuborganizationId)
    )
    if (response) setsuborg(response)
  }
  const getInstance = async () => {
    const response = await dispatch(
      getApplicationInstanceEAuthz(item.applicationInstanceId)
    )
    if (response) setdetails(response)
  }

  useEffect(async () => {
    setloading(true)
    if (item) {
      await getInstance()
      await getSubOrg()
    }
    setloading(false)
  }, [item])

  const getIconStatus = (status) => {
    switch (status) {
      case 'GRANTED':
        return (
          <Tooltip title="GRANTED">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )

      default:
        return (
          <Tooltip title={status.userStatusName}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
    }
  }

  return (
    <tr>
      {details && !loading && (
        <>
          <td className={classes.itemCheck}>
            <Checkbox />
          </td>
          <td className={classes.itemIcon}>
            {getIconStatus(details.orgAppAccessStatusCode || '')}
          </td>
          <td className={classes.organizationName}>
            {suborg ? suborg.suborganizationName : ''}
          </td>
          <td className={classes.cuit}> {suborg.suborganizationCuit}</td>

          <td className={classes.date}>
            {formatDate(details.accessStartDate)
              ? formatDate(details.accessStartDate)
              : 'Fecha no definida'}{' '}
            /{' '}
            {formatDate(details.accessFinishDate)
              ? formatDate(details.accessFinishDate)
              : 'Fecha no definida'}
          </td>
          {/* <td className={classes.numberOfActiveUser}>
            {details.activeAppUserCount || 0}
          </td>
          <td className={classes.numberOfDerivedUser}>
            {' '}
            {details.activeExternalAppUserCount}
          </td> */}
          <td className={classes.numberOfModules}>
            {details.appModules?.length}
          </td>
          <td className={classes.itemKebab}>
            <ModalMenuItem item={item} setLoading={setloading} />
          </td>
        </>
      )}
    </tr>
  )
}

export default TableItem
